<div class="widget">
  <div class="amSuite-widget-header">
    {{ 'widgets.last-parties.title' | translate }}
  </div>
  <div class="amSuite-widget-block height-auto">
    
    @if (isLoading) {
    <div class="skeleton-grid">
      @for (item of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]; track item) {
      <div class="skeleton-box">
        <div class="skeleton-name"></div>
        <div class="skeleton-codes">
          <div class="skeleton-badge"></div>
          <div class="skeleton-badge"></div>
        </div>
      </div>
      }
    </div>
    }
    @else if (hasDatas()) {
    <div class="party-grid">
      @for (p of visitedParties; track $index) {
      <div class="party-box" (click)="onSelectParty(p)">
        <div class="party-name">{{ p.fullName }}</div>
        <div class="party-codes">
          @if (p.smartCode) {
          <span class="code-badge code-primary">{{ p.smartCode }}</span>
          }
          @if (p.taxPayerCode) {
          <span class="code-badge code-tertiary">{{ p.taxPayerCode }}</span>
          }
        </div>
      </div>
      }
    </div>
    }
    @else {
    <p class="no-data-message">
      {{ 'widgets.last-parties.noData' | translate }}
    </p>
    }
  </div>
</div>